import { firebaseConnect } from 'react-redux-firebase'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withHandlers, withState } from 'recompose'
import moment from 'moment'
import Timesheet from './Timesheet'
import { setDate } from '../../helpers/helpers'

const d = new Date()
const year = d.getFullYear()
const month = d.getMonth() + 1
const day = d.getDate()
const defaultCurrentMonth = `${year}-${month}-${day}`

const enhance = compose(
  firebaseConnect((props, store) => {
    return [
      'profile',
      { path: `projects/${store.getState().firebase.auth.uid}` },
      { path: `timesheets/${store.getState().firebase.auth.uid}` }
    ]
  }),
  connect(({ firebase: { profile, data, auth } }) => ({
    profile,
    projects: data.projects && data.projects[auth.uid],
    timesheets: data.timesheets && data.timesheets[auth.uid]
  })),
  withState('currentMonth', 'setCurrentMonth', defaultCurrentMonth),
  withHandlers({
    updateTimeSheet: ({ profile, firebase, auth, currentMonth }) => (
      key,
      hours
    ) => {
      const currentDate = moment(setDate(new Date(currentMonth)))
      const selectedProjectId = profile.selectedProject
      const year = currentDate.format('YYYY')
      const month = currentDate.format('MMMM')

      firebase.set(
        `timesheets/${auth.uid}/${selectedProjectId}/${year}/${month}/${key}`,
        hours
      )
    },
    selectMonth: props => event => {
      props.setCurrentMonth(event)
    }
  })
)

export default enhance(Timesheet)



// WEBPACK FOOTER //
// ./src/components/Timesheet/TimesheetContainer.js